import axios from "axios";

export function init() {
     // Find the corresponding Form
     const forms = document.querySelectorAll('.js-freeform'),
        form = forms[0] ?? false;
    
    if (form) {
        axios.get(`/ajax/freeform?form=${form.dataset.handle}`, {
            headers: { "X-Requested-With": "XMLHttpRequest" }
        })
        .then (response => {
            // Update the Form Hash
            form.querySelector('input[name=formHash]').value = response.data.hash;

            // Update the JS Honeypot (ONLY when JS Enhancement setting is ON)
            // var honeypot = response.data.honeypot;
            // var honeypotInput = form.querySelector('input[name^="freeform_form_handle"]');
            // honeypotInput.setAttribute('id', honeypot.name);
            // honeypotInput.setAttribute('name', honeypot.name);
            // honeypotInput.value = honeypot.hash;

            // Locate and update the CSRF input
            var csrf = response.data.csrf;
            form.querySelector(`input[name=${csrf.name}]`).value = csrf.value;
        });
    }
}